import { nameOf } from '../../app/shared/common';
import { QueryParser } from '../../app/shared/QueryParser';

export class TermsQuery {
  brand?: string;
}

export const BRAND = nameOf<TermsQuery>('brand');

export class TermsQueryParser extends QueryParser {
  public static toModel(query: Map<string, string>): TermsQuery {
    const queryModel = new TermsQuery();

    queryModel.brand = QueryParser.getValue(query, BRAND);

    return queryModel;
  }

  public static toQuery(queryModel: TermsQuery): Map<string, string> {
    const query = new Map<string, string>();

    QueryParser.setValue(query, BRAND, queryModel.brand);

    return query;
  }
}
